"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewStripeSession extends new_item_1.default {
    constructor(newStripeSession) {
        super();
        this.url = newStripeSession.url;
    }
}
exports.default = NewStripeSession;
//# sourceMappingURL=new-stripeSession.js.map